import { useToolbarStore } from '../../store/VitalStore';
//UI
import AdminList from './AdminList';
import PanelList from './PanelList';
import { API_BASE_URL } from '../../store/constans';

const NavLeft = () => {

  const { isToolbarOpen, closeToolbar } = useToolbarStore((state) => state);
  const user = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div
      className={`text-gray-600 overflow-y-scroll contenedor	shadow-md fixed top-0 bottom-0 md:translate-x-0 transition-all w-60 bg-white z-20 ${isToolbarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
    >
      <div className="flex items-center px-5 justify-center gap-2 my-5 h-16 z-20 relative">
        <img className="object-contain h-[80px] md:h-[70px] 2xl:h-[80px] " src={API_BASE_URL + user?.logo} alt="logo" />
      </div>
      <ul className="flex flex-col h-full items-start justify-start w-full gap-2 z-20 relative ">
        {user.role === 'Administrador' ?
          <AdminList /> : ""
        }
        <PanelList />
      </ul>

    </div>
  );
};

export default NavLeft;
